import { createApp } from 'vue';
import App from './App.vue';
import Swal from 'sweetalert2';

// import components
import globalComponents from './plugins/globalComponents';
// import services
import services from './plugins/services';
// import MSAL plugin
import msalPlugin from './plugins/msal/plugin';
import msalInstance from './plugins/msal/index.js';
import { loginRequest } from './plugins/msal/index.js';

// import helpers
import { setCookie } from './helpers/cookie';
import { setUserDetails } from './helpers/user';
import http from './plugins/axios';
import router from './router';
import { initializeDatadogRum } from './plugins/datadog/rum';

// import tooltip
import FloatingVue from 'floating-vue';
import 'floating-vue/dist/style.css';

initializeDatadogRum();

const app = createApp(App);

// Função para processar login completo após redirect
async function processLoginAfterRedirect(loginResponse) {
  try {
    // Obter access token do Azure AD
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length === 0) {
      throw new Error('Nenhuma conta encontrada após login');
    }

    const silentRequest = {
      ...loginRequest,
      account: accounts[0],
    };

    const tokenResponse = await msalInstance.acquireTokenSilent(silentRequest);
    const { accessToken } = tokenResponse;

    // Chamar API do backend para obter informações adicionais
    const { data } = await http.get('/Login/AdditionalInformation', {
      headers: {
        'Authorization': `Bearer ${accessToken}`
      }
    });

    // Armazenar token e userId nos cookies
    setCookie('token', data.token, 23);
    setCookie('userId', data.userId);

    // Armazenar informações do usuário no localStorage
    setUserDetails(JSON.stringify({
      name: loginResponse.account.name || 'User',
      id: data.userId,
      email: loginResponse.account.username
    }));

    // Redirecionar para home
    router.push({ name: 'home' });
  } catch (error) {
    Swal.fire({
      title: 'Erro na autenticação',
      html: `Erro ao completar login: ${error.message || 'Erro desconhecido'}. <br/> Por favor, tente fazer login novamente.`,
      icon: 'error',
      confirmButtonText: 'Ok',
    });
  }
}

// Tratar redirect do MSAL antes de montar a aplicação
msalInstance.initialize().then(async () => {
  try {
    // Lidar com redirect promise se houver
    const response = await msalInstance.handleRedirectPromise();

    if (response) {
      // Redirect foi processado com sucesso - completar login
      await processLoginAfterRedirect(response);
    }
  } catch (error) {
    // Ignorar hash_empty_error quando não há hash (comportamento normal)
    if (error.errorCode !== 'hash_empty_error') {
      Swal.fire({
        title: 'Erro na autenticação',
        html: `Erro ao processar redirect do MSAL: ${error.message || 'Erro desconhecido'}. <br/> Por favor, tente fazer login novamente.`,
        icon: 'error',
        confirmButtonText: 'Ok',
      });
    }
  }
});

// use components
app.use(globalComponents);

// use services
app.use(services);

// use MSAL plugin
app.use(msalPlugin);

// use tooltip
app.use(FloatingVue);

app.mount('#app');
